import { createSlice } from "@reduxjs/toolkit";

import type { GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

import type { CheckoutV2Error, CheckoutV2LoyaltyState, CheckoutV2State, SectionState } from "./checkoutV2Slice.types";

const loyaltyStateInitial: CheckoutV2LoyaltyState = {
  loyaltyChoice: undefined,
  loyaltyCampaignId: "",
  isLoyaltyError: false,
};

export const initialState: CheckoutV2State = {
  sectionsState: {
    shippingSection: "active",
    paymentSection: "rested",
    orderConfirmationSection: "rested",
  },
  data: null,
  error: null,
  loyaltyPointsState: loyaltyStateInitial,
};

export const checkoutV2Slice = createSlice({
  name: "checkoutV2",
  initialState,
  reducers: {
    resetState: () => initialState,
    setData(state, action: { payload: Partial<CheckoutV2State["data"]> }) {
      if (state.data) {
        state.data = { ...state.data, ...action.payload };
        return;
      }
      state.data = action.payload;
    },
    setSectionsState(state, action: { payload: CheckoutV2State["sectionsState"] }) {
      state.sectionsState = action.payload;
    },
    setShippingSectionState(state, action: { payload: SectionState }) {
      state.sectionsState.shippingSection = action.payload;
    },
    setPaymentSectionState(state, action: { payload: SectionState }) {
      state.sectionsState.paymentSection = action.payload;
    },
    setOrderConfirmationSectionState(state, action: { payload: SectionState }) {
      state.sectionsState.orderConfirmationSection = action.payload;
    },
    setError(state, action: { payload: CheckoutV2Error }) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
    clearLoyaltyState(state) {
      state.loyaltyPointsState = loyaltyStateInitial;
    },
    setLoyaltyChoice(state, action: { payload: CheckoutV2LoyaltyState["loyaltyChoice"] }) {
      state.loyaltyPointsState.loyaltyChoice = action.payload;
      state.loyaltyPointsState.isLoyaltyError = false;
    },
    setLoyaltyCampaignId(state, action: { payload: string }) {
      state.loyaltyPointsState.loyaltyCampaignId = action.payload;
    },
    setLoyaltyError(state, action: { payload: boolean }) {
      state.loyaltyPointsState.isLoyaltyError = action.payload;
    },
    setLoyaltyPoints(state, action: { payload: number }) {
      state.loyaltyPointsState.loyaltyPoints = action.payload;
    },
    setLoyaltyVoucher(state, action: { payload: GetEligibleCampaignsResponseType }) {
      state.loyaltyPointsState.loyaltyVoucher = action.payload;
    },
  },
});
